import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import {  TranslateService } from 'ng2-translate';
import { environment } from '../../../environments/environment';

@Injectable()
export class ServiciosStatsProvider {

	urlStatsVisitas = '/Visitas';

	MESES = {};

	constructor(public http: Http, public translate: TranslateService) {
		this.urlStatsVisitas = environment.ubimapsStats + this.urlStatsVisitas;

		for (let i = 1; i <= 12; i++) {
			const _mes = '' + i;

			this.MESES[_mes] = this.translate.instant('Graficas.Mes' + _mes);

		}

	}

	migrarBDStat(token, idEntidad){

		if (!confirm('Vas a proceder a migrar la BD de estadísticas. ¿Quieres continuar?')){
			alert('Operacion cancelada');
			return;
		}


		const fecha = new Date();
		const tiempoInicial = fecha.getTime();

		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		this.http.get(environment.apiUrl + '/diagnostico/MigrarStatsBD?idEntidad=' + idEntidad, {headers: headers})
			.subscribe(function (res) {
				const fecF = new Date();
				const tiempoTotal = fecF.getTime() - tiempoInicial;

				console.log(tiempoTotal);
				console.log(res);
				alert('Hecho');
			});

	}

	statsVisitaCuenta(token, filtro, _callback) {
		// console.log('INICIADOS STATS');

		const fec = new Date();
		const tiempoInicial = fec.getTime();


		let cadena = '?';
		let _n = 0;
		for (const i in filtro) {
			if (_n > 0) {
				cadena += '&';
			}
			cadena += i + '=' + filtro[i];
			_n++;
		}
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);

		this.http.get(this.urlStatsVisitas + cadena, {headers: headers})
			.subscribe(function (res) {
				const fecF = new Date();
				const tiempoTotal = fecF.getTime() - tiempoInicial;
				const resultado = res.json();
				resultado.tiempo = tiempoTotal;
				_callback(resultado);
			});
	}

	fechaToCubefec(fec: Date = new Date(), separador: string = '') {
		const _mesN = fec.getMonth() + 1;
		let mes = '' + _mesN;
		let dia = '' + fec.getDate();
		let hora = '' + fec.getHours();
		let minuto = '' + fec.getMinutes();

		if (_mesN < 10) {
			mes = '0' + _mesN;
		}

		if (fec.getDate() < 10) {
			dia = '0' + fec.getDate();
		}

		if (fec.getHours() < 10) {
			hora = '0' + fec.getHours();
		}

		if (fec.getMinutes() < 10) {
			minuto = '0' + fec.getMinutes();
		}

		const year = fec.getFullYear();

		return {
			fecha: year + separador + mes + separador + dia,
			hora: hora + separador + minuto
		};
	}

	getLastMonthsRange(months){
		const actual = new Date();

		const last = new Date();
		last.setDate(1);
		last.setMonth(last.getMonth() - months);

		const actualCub = this.fechaToCubefec(actual);
		const lastCub = this.fechaToCubefec(last);

		return lastCub.fecha + ',' + actualCub.fecha;
	}

	getWeekRange(_actual: Date, inDate: Boolean) {
		const actual = new Date(_actual);
		const actual2 = new Date(_actual);

		const day = actual.getDay();
		const diffMon = actual.getDate() - day + (day === 0 ? -6 : 1);
		const diffSun = actual2.getDate() + 7 - day;

		const monday = new Date(actual.setDate(diffMon));

		const sunday = new Date(actual2.setDate(diffSun));

		if (inDate){
			return {
				monday: monday,
				today: _actual,
				sunday: sunday
			};
		}

		const mondayCub = this.fechaToCubefec(monday);
		const actualCub = this.fechaToCubefec(_actual);

		return mondayCub.fecha + ',' + actualCub.fecha;
	}

	/* ** ACTIVOS ** */
	getHistoricoLocalizacionesContenidos(token, idsContenidos, fechaDesde: Date, fechaHasta: Date) {
		const headers = new Headers();

		let fd = '';
		if (fechaDesde) {
			const mes = fechaDesde.getUTCMonth() + 1;
			const dia = fechaDesde.getUTCDate();
			const anio =  fechaDesde.getUTCFullYear();
			const hora =  fechaDesde.getUTCHours();
			const minutos =  fechaDesde.getUTCMinutes();

			fd = anio.toString().padStart(4, '0') + '-' +
			mes.toString().padStart(2, '0') + '-' +
			dia.toString().padStart(2, '0') + ' ' +
			hora.toString().padStart(2, '0') + ':' +
			minutos.toString().padStart(2, '0');

			// fd = fechaDesde.toTimeString();
		}
		let fh = '';
		if (fechaHasta) {
			const mes = fechaHasta.getUTCMonth() + 1;
			const dia = fechaHasta.getUTCDate();
			const anio =  fechaHasta.getUTCFullYear();
			const hora =  fechaHasta.getUTCHours();
			const minutos =  fechaHasta.getUTCMinutes();

			// fh = dia + '/' + mes + '/' + anio;
			fh = anio.toString().padStart(4, '0') + '-' +
			mes.toString().padStart(2, '0') + '-' +
			dia.toString().padStart(2, '0') + ' ' +
			hora.toString().padStart(2, '0') + ':' +
			minutos.toString().padStart(2, '0');

			// fh = fechaHasta.toTimeString();
		}

		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			Contenidos: idsContenidos,
			FechaDesde: fd,
			FechaHasta: fh
		};

		return this.http.post(environment.ubimapsStats + 'ObtenerHistoricoLocalizacionesContenidos', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	// ObtenerUltimoHistoricoLocalizacionesContenidos
	// obtenemos las ultimas localizaciones del contenido en la tabla historicos que ha de tener todas sus posiciones
	// Filtramos y cogemos solo las localizaciones del ultimo dia ya que consideramos que si no esta hubicado hoy en el sitio no va a estar ahi
	getUltimoHistoricoLocalizacionesContenidos(token, idsContenidos) {
		const headers = new Headers();

		const fd = '01/01/1990';
		/*
		const fechaDesde = new Date();
		if (fechaDesde) {
			const mes = fechaDesde.getMonth() + 1;
			const dia = fechaDesde.getDate() - 1;
			const anio =  fechaDesde.getFullYear();
			fd = dia + '/' + mes + '/' + anio;
		}
		*/

		let fh = '';
		const fechaHasta = new Date();
		if (fechaHasta) {
			const mes = fechaHasta.getUTCMonth() + 1;
			const dia = fechaHasta.getUTCDate();
			const anio =  fechaHasta.getUTCFullYear();
			fh = anio.toString().padStart(4, '0') + '-' + mes.toString().padStart(2, '0') + '-' + dia.toString().padStart(2, '0');
		}

		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			Contenidos: idsContenidos,
			FechaDesde: fd,
			FechaHasta: fh
		};

		return this.http.post(environment.ubimapsStats + 'ObtenerUltimoHistoricoLocalizacionesContenidos', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	getLocalizacionTiempoRealContenidos(token, idsContenidos) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			Contenidos: idsContenidos
		};

		return this.http.post(environment.ubimapsStats + 'ObtenerLocalizacionTiempoRealContenidos', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	getLocalizacionTiempoRealContenidos_ext(token, idsContenidos) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			Contenidos: idsContenidos
		};

		return this.http.post(environment.ubimapsStats + 'ObtenerLocalizacionTiempoRealContenidos_ext', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

	getCoincidenciasLocalizacion(token, idsContenidos, fechaDesde: Date, fechaHasta: Date) {
		const headers = new Headers();

		let fd = '';
		if (fechaDesde) {

			const mes = fechaDesde.getUTCMonth() + 1;
			const dia = fechaDesde.getUTCDate();
			const anio =  fechaDesde.getUTCFullYear();
			const hora =  fechaDesde.getUTCHours();
			const minutos =  fechaDesde.getUTCMinutes();

			fd = anio.toString().padStart(4, '0') + '-' +
			mes.toString().padStart(2, '0') + '-' +
			dia.toString().padStart(2, '0') + ' ' +
			hora.toString().padStart(2, '0') + ':' +
			minutos.toString().padStart(2, '0');

			// fd = fechaDesde.toISOString();

		}
		let fh = '';
		if (fechaHasta) {

			const mes = fechaHasta.getUTCMonth() + 1;
			const dia = fechaHasta.getUTCDate();
			const anio =  fechaHasta.getUTCFullYear();
			const hora =  fechaHasta.getUTCHours();
			const minutos =  fechaHasta.getUTCMinutes();

			// fh = dia + '/' + mes + '/' + anio;
			fh = anio.toString().padStart(4, '0') + '-' +
			mes.toString().padStart(2, '0') + '-' +
			dia.toString().padStart(2, '0') + ' ' +
			hora.toString().padStart(2, '0') + ':' +
			minutos.toString().padStart(2, '0')
			;

			// fh = fechaHasta.toISOString();
		}

		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', 'Bearer ' + token);
		const body = {
			Contenidos: idsContenidos,
			FechaDesde: fd,
			FechaHasta: fh
		};

		return this.http.post(environment.ubimapsStats + 'ObtenerCoincidenciasLocalizacion', JSON.stringify(body), { headers: headers }).map(res => res.json());
	}

}






// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/web-service-service/servicios-stats.ts